module.exports = __webpack_public_path__ + "static/media/fondo1.17f799f5.jpg";